import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

const Label = ({ isVisible, orientation, style, children }) => {
  const labelStyles =
    orientation === 'flipped-up'
      ? {
          top: 0,
          left: 0,
          transform: 'translate(5%, -125%)',
        }
      : orientation === 'up'
        ? {
            top: 0,
            left: 0,
            transform: 'translate(-60%, -140%)',
          }
        : {
            bottom: 0,
            right: 0,
            transform: 'translate(60%, 140%)',
          };

  return (
    <LabelWrapper
      style={{
        ...style,
        opacity: isVisible ? 1 : 0,
      }}
    >
      <LabelText style={labelStyles}>{children}</LabelText>

      <Stem
        src="/images/stem.png"
        style={{
          transform:
            orientation === 'flipped-up'
              ? 'rotate(90deg)'
              : orientation === 'up'
                ? 'rotate(180deg)'
                : undefined,
        }}
      />
    </LabelWrapper>
  );
};

const LabelWrapper = styled.div`
  position: absolute;
  width: 50px;
  transition: opacity 500ms;

  @media ${BREAKPOINTS.smAndSmaller} {
    display: none;
  }

  html[data-color-mode='dark'] & {
    filter: invert(100%);
  }
`;

const LabelText = styled.span`
  position: absolute;
  display: block;
  font-size: 0.75rem;
  font-family: var(--font-family-mono);
  white-space: nowrap;
  color: black;
`;

const Stem = styled.img`
  display: block;
  width: 100%;
  transform-origin: center center;
`;

export default Label;
